(function () {

  /* ── FAQ Accordion ─────────────────────────────────────────── */
  function initFaq() {
    var btns = document.querySelectorAll('.bt2-faq-q');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ans    = this.nextElementSibling;
        var isOpen = this.classList.contains('bt2-open');

        /* close all */
        document.querySelectorAll('.bt2-faq-q').forEach(function (b) {
          b.classList.remove('bt2-open');
          if (b.nextElementSibling) {
            b.nextElementSibling.classList.remove('bt2-open');
          }
        });

        /* open clicked one if it was closed */
        if (!isOpen) {
          this.classList.add('bt2-open');
          if (ans) ans.classList.add('bt2-open');
        }
      });
    });
  }

  /* ── Mobile TOC Toggle ─────────────────────────────────────── */
  /* Covers all article styles: .toc-title / .bt2-toc-title      */
  function initMobileToc() {
    var titles = document.querySelectorAll('.toc-title, .bt2-toc-title');
    titles.forEach(function (title) {
      var list = title.nextElementSibling;
      if (!list) return;

      title.addEventListener('click', function () {
        var open = this.classList.toggle('open');
        if (open) {
          list.classList.add('open');
        } else {
          list.classList.remove('open');
        }
      });

      /* close TOC when any link inside is clicked */
      list.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          title.classList.remove('open');
          list.classList.remove('open');
        });
      });
    });
  }

  /* ── TOC Scroll Highlight ──────────────────────────────────── */
  function initToc() {
    var secs = document.querySelectorAll(
      '.bt2-section[id], .bt-section[id], .section[id]'
    );
    var lnks = document.querySelectorAll(
      '.bt2-toc-list a, .bt-toc-list a, .toc-list a'
    );
    if (!secs.length || !lnks.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          lnks.forEach(function (a) {
            a.classList.remove('bt2-active', 'bt-active', 'active');
          });
          var sel =
            '.bt2-toc-list a[href="#' + e.target.id + '"],' +
            '.bt-toc-list a[href="#'  + e.target.id + '"],' +
            '.toc-list a[href="#'     + e.target.id + '"]';
          var match = document.querySelector(sel);
          if (match) {
            match.classList.add('bt2-active');
            match.classList.add('active');
          }
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });

    secs.forEach(function (s) { obs.observe(s); });
  }

  /* ── Init ──────────────────────────────────────────────────── */
  function init() {
    initFaq();
    initMobileToc();
    initToc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();